<!-- ========== App Menu ========== -->
<div class="app-menu navbar-menu">
    <!-- LOGO -->
    <div class="navbar-brand-box">
      <!-- Dark Logo-->
      <a routerLink="/" class="logo logo-dark">
        <span class="logo-sm">
          <img src="assets/images/zalon-logo.svg" alt="" height="25">
        </span>
        <span class="logo-lg">
          <span style="color: #fff; font-weight:600;font-size:16px;margin-left:10px"> ZALON</span>
          <span class="powered-by">Powered by Z Revolution</span>
        </span>
      </a>
      <!-- Light Logo-->
      <a routerLink="/" class="logo logo-light">
        <span class="logo-sm">
          <!-- <img src="assets/images/zalon-logo.svg" alt="" height="25"> -->
        </span>
        <span class="logo logo-lg ">
          <img src="assets/images/zalon-logo.svg" alt="" height="25">
          <span style="color: #fff; font-weight:600;font-size:16px;margin-left:10px"> ZALON</span>
          <span class="powered-by">Powered by Z Revolution</span>
        </span>
      </a>
      <button type="button" class="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover" id="vertical-hover"
        (click)="toggleMobileMenu($event)">
        <i class="ri-record-circle-line"></i>
      </button>
    </div>
  
    <div id="scrollbar" style="margin-top: 20px;">
      <div class="container-fluid">
        <div id="two-column-menu"></div>
        
        <ngx-simplebar class="sidebar-menu-scroll" style="max-height: calc(100vh - 70px)">
          <ul class="metismenu list-unstyled navbar-nav mb-5" id="navbar-nav">
            <ng-container *ngFor="let item of menuItems">
              <li class="nav-item" *ngIf="!item.isTitle && !item.isLayout">
                
                <!-- Parent Menu Item with children -->
                <a *ngIf="hasItems(item)" 
                   href="javascript:void(0);" 
                   class="nav-link menu-link"
                   [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}"
                   data-bs-toggle="collapse" 
                   aria-expanded="false" 
                   (click)="toggleItem($event)">
                  <i class="{{ item.icon }} icon nav-icon"></i>
                  <span>{{ item.label | translate }}</span>
                  <span class="{{item.badge.variant}}" *ngIf="item.badge">
                    {{item.badge.text | translate}}
                  </span>
                </a>
                
                <!-- Single Menu Item (No children) -->
                <a [routerLink]="item.link" 
                   *ngIf="!hasItems(item)" 
                   class="nav-link menu-link" 
                   routerLinkActive="active"
                   (click)="onMenuItemClick()">
                  <i class="bx {{ item.icon }} icon nav-icon" *ngIf="item.icon"></i>
                  <span>{{ item.label | translate }}</span>
                  <span class="{{item.badge.variant}}" *ngIf="item.badge">
                    {{item.badge.text | translate}}
                  </span>
                </a>
                
                <!-- First Level Sub-menu -->
                <div class="collapse menu-dropdown" *ngIf="hasItems(item)">
                  <ul class="nav nav-sm flex-column" aria-expanded="false">
                    <li *ngFor="let subitem of item.subItems" class="nav-item">
                      
                      <!-- Sub-item link (Final) -->
                      <a [routerLink]="subitem.link" 
                         *ngIf="!hasItems(subitem)" 
                         class="nav-link"
                         [attr.data-parent]="subitem.parentId" 
                         routerLinkActive="active"
                         (click)="onMenuItemClick()">
                        {{ subitem.label | translate}}
                        <span class="{{subitem.badge.variant}}" *ngIf="subitem.badge">
                          {{subitem.badge.text | translate}}
                        </span>
                      </a>
                      
                      <!-- Sub-item with its own children -->
                      <a *ngIf="hasItems(subitem)" 
                         class="nav-link" 
                         href="javascript:void(0);"
                         [attr.data-parent]="subitem.parentId" 
                         data-bs-toggle="collapse" 
                         aria-expanded="false" 
                         (click)="toggleSubItem($event)">
                        {{ subitem.label | translate}}
                        <span class="{{subitem.badge.variant}}" *ngIf="subitem.badge">
                          {{subitem.badge.text | translate}}
                        </span>
                      </a>
                      
                      <!-- Second Level Sub-menu -->
                      <div class="collapse menu-dropdown sub-menu" *ngIf="hasItems(subitem)">
                        <ul class="nav nav-sm flex-column" aria-expanded="false">
                          <li *ngFor="let subSubitem of subitem.subItems" class="nav-item">
                            
                            <!-- Sub-sub-item link (Final) -->
                            <a [routerLink]="subSubitem.link" 
                               *ngIf="!hasItems(subSubitem)" 
                               class="nav-link"
                               [attr.data-parent]="subSubitem.parentId" 
                               routerLinkActive="active"
                               (click)="onMenuItemClick()">
                              {{ subSubitem.label | translate}}
                              <span class="{{subSubitem.badge.variant}}" *ngIf="subSubitem.badge">
                                {{subSubitem.badge.text | translate}}
                              </span>
                            </a>
                            
                            <!-- Sub-sub-item with its own children -->
                            <a *ngIf="hasItems(subSubitem)" 
                               class="nav-link" 
                               href="javascript:void(0);"
                               [attr.data-parent]="subSubitem.parentId" 
                               data-bs-toggle="collapse" 
                               aria-expanded="false"
                               (click)="toggleExtraSubItem($event)">
                              {{ subSubitem.label | translate}}
                              <span class="{{subSubitem.badge.variant}}" *ngIf="subSubitem.badge">
                                {{subSubitem.badge.text | translate}}
                              </span>
                            </a>
                            
                            <!-- Third Level Sub-menu -->
                            <div class="collapse menu-dropdown extra-sub-menu" *ngIf="hasItems(subSubitem)">
                              <ul class="nav nav-sm flex-column" aria-expanded="false">
                                <li *ngFor="let subSubitem1 of subSubitem.subItems" class="nav-item">
                                  <a [attr.data-parent]="subSubitem1.parentId" 
                                     [routerLink]="subSubitem1.link"
                                     routerLinkActive="active" 
                                     class="nav-link"
                                     (click)="onMenuItemClick()">
                                    {{ subSubitem1.label | translate }}
                                    <span class="{{subSubitem1.badge.variant}}" *ngIf="subSubitem1.badge">
                                      {{subSubitem1.badge.text | translate}}
                                    </span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
            </ng-container>
          </ul>
        </ngx-simplebar>
      </div>
      <!-- Sidebar -->
    </div>
    <div class="sidebar-background"></div>
  </div>
  <!-- Left Sidebar End -->
  
  <!-- Vertical Overlay-->
  <div class="vertical-overlay" (click)="SidebarHide()"></div>